function findUsedAttributes(nodes) {

    const attributeMap = {};

    nodes
        .filter(node => node.type !== 'root')
        .flatMap(extractUsedAttributesFromNode)
        .forEach(attr => {
            const key = `${attr.name}::${attr.data_type}`;
            if (!attributeMap[key]) {
                attributeMap[key] = {
                    name: attr.name,
                    data_type: attr.data_type,
                    count: 0
                };
            }
            attributeMap[key].count += 1;
        });

    const usedAttributeSet = attributeMap;

    return nodes.map(node => {
        if (node.type === 'root') return {
            ...node,
            data: {
                ...node.data,
                general_properties: {
                    ...node.data.general_properties,
                    used_resource_attributes: usedAttributeSet
                }
            }
        };

        return node;
    });
}

function extractUsedAttributesFromNode(node) {
    if (node.type === 'selection' && node?.data?.general_properties?.resource_schema) {
        return node?.data?.general_properties?.resource_schema
            .filter(attr => attr.checked === true)
            .map(attr => ({ name: attr.name, data_type: attr.data_type }));
    }

    if (
        node.type === 'condition' &&
        node.data?.general_properties?.conditions
    ) {
        return node.data.general_properties.conditions.flatMap(condition =>
            (condition.subConditions || [])
                .map(sub => ({
                    name: sub?.resourceAttribute?.name,
                    data_type: sub?.resourceAttribute?.data_type
                }))
                .filter(attr => attr.name && attr.data_type)
        );
    }

    if (node.type === 'privacy' && node.data?.general_properties?.privacies.length > 0) {
        return node?.data?.general_properties?.privacies
            .map(privacy => ({ name: privacy?.attribute?.name, data_type: privacy?.attribute?.data_type }));
    }

    // case อื่นๆ
    return [];
}

export default findUsedAttributes;